import {Component, Inject, OnInit, ViewContainerRef} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {LocalStoreService, StoreSelectorsService} from "../../services";
import * as htmlToImage from "html-to-image";

@Component({
    selector: 'app-dialog-qr-generate',
    templateUrl: './dialog-qr-generate.component.html',
    styleUrls: ['./dialog-qr-generate.component.scss']
})
export class DialogQrGenerateComponent implements OnInit {
    m_data;
    el: HTMLElement;

    constructor(public dialogRef: MatDialogRef<any>,
                private storeSelector: StoreSelectorsService,
                private viewContainer: ViewContainerRef,
                private localStoreService: LocalStoreService,
                @Inject(MAT_DIALOG_DATA) public data: any) {
        this.el = this.viewContainer.element.nativeElement;
        if (data) {
            this.m_data = data.url;
        }
    }

    ngOnInit(): void {
    }

    downloadQR() {
        const element = document.getElementsByClassName('printableArea').item(0) as HTMLElement;
        htmlToImage.toJpeg(element, {quality: 0.95})
            .then((dataUrl) => {
                const link = document.createElement('a');
                link.download = 'screen-capture.jpeg';
                link.href = dataUrl;
                link.click();
            });
    }

}


// const printContents = document.getElementById('printableArea').innerHTML;
// const originalContents = document.body.innerHTML;
// document.body.innerHTML = printContents;
// window.print();
// document.body.innerHTML = originalContents;
// this.printing = true;
// this.showProgress = false;
// const mywindow = window.open('', 'QR Code', 'height=400,width=600');
// setTimeout(() => {
//     const printContents = this.el.innerHTML;
//     // var mywindow = window.open('', self.selectedOrder.getDate(), 'height=400,width=600');
//     mywindow.document.write(`<html><head><title>${this.getOrderId()}</title>`);
//     /*optional stylesheet*/ //
//     mywindow.document.write('</head><body >');
//     // mywindow.document.write('<link rel="stylesheet" href="http://localhost:9089/src/styles/style.css" type="text/css" />');
//     mywindow.document.write(printContents);
//     mywindow.document.write('</body></html>');
//     mywindow.document.close(); // necessary for IE >= 10
//     mywindow.focus(); // necessary for IE >= 10
//     mywindow.print();
//     mywindow.close();
// }, 1000);
// setTimeout(() => {
//     this.printing = false;
// }, 10000);
// return true;
